import Popup from 'reactjs-popup';
import Proptypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { UsersSelectors } from '../../../Redux/modules/users/selectors';
import { UsersActions } from '../../../Redux/modules/users/actions';
import EditProfileModal from './ActionModals/EditProfileModal';
import RemoveInviteModal from './ActionModals/RemoveInviteModal';
import RemoveUserModal from './ActionModals/RemoveUserModal';
import ResendInviteModal from './ActionModals/ResendInviteModal';
import ResetPasswordModal from './ActionModals/ResetPasswordModal';
import UpdatePermissionsModal from './ActionModals/UpdatePermissionsModal';
import AssignToTeamsModal from './ActionModals/AssignToTeamsModal';
import { ProfileSelectors } from '../../../Redux/modules/profile/selectors';

const Modals = (props) => {
  const { currentUser, actions, close, isTrial, trialEndDate, availableSubscriptions, currentLoggedEmail } = props;
  const onModalOpen = (actionItem) => {
    if (actionItem.name === 'EDIT_PROFILE') {
      return props.editProfileModalOpen;
    }
    if (actionItem.name === 'RESET_PASSWORD') {
      return props.resetPasswordModalOpen;
    }
    if (actionItem.name === 'ASSIGN_TO_TEAMS') {
      return props.assignToTeamsModalOpen;
    }
    if (actionItem.name === 'UPDATE_PERMISSIONS') {
      return props.updatePermissionsModalOpen;
    }
    if (actionItem.name === 'REMOVE_USER') {
      return props.removeUserModalOpen;
    }
    if (actionItem.name === 'RESEND_INVITE') {
      return props.resendInviteModalOpen;
    }
    if (actionItem.name === 'REMOVE_INVITE') {
      return props.removeInviteModalOpen;
    }
    return false;
  };
  const getModal = (item, userData) => {
    let modal;

    switch (item.name) {
      case 'EDIT_PROFILE':
        modal = <EditProfileModal userData={userData} title={item.title} />;
        break;
      case 'RESET_PASSWORD':
        modal = <ResetPasswordModal userData={userData} title={item.title} />;
        break;
      case 'ASSIGN_TO_TEAMS':
        modal = <AssignToTeamsModal userData={userData} title={item.title} />;
        break;
      case 'UPDATE_PERMISSIONS':
        modal = (
          <UpdatePermissionsModal
            userData={userData}
            isTrial={isTrial}
            availableSubscriptions={availableSubscriptions}
            trialEndDate={trialEndDate}
            currentLoggedEmail={currentLoggedEmail}
          />
        );
        break;
      case 'REMOVE_USER':
        modal = <RemoveUserModal userData={userData} title={item.title} />;
        break;
      case 'RESEND_INVITE':
        modal = <ResendInviteModal userData={userData} title={item.title} />;
        break;
      case 'REMOVE_INVITE':
        modal = <RemoveInviteModal userData={userData} title={item.title} />;
        break;

      default:
        modal = <EditProfileModal userData={userData} title={item.title} />;
    }

    return modal;
  };

  const getModalStyle = () => {
    return {
      width: '528px',
      boxShadow: 'rgba(101, 101, 101, 0.28) 0px 4px 12px 0px',
      border: 'none',
      borderRadius: '8px',
      padding: '40px 80px',
      backgroundColor: '#ffffff',
    };
  };
  return (
    <>
      {actions.map((item) => (
        <Popup
          key={item.name}
          contentStyle={getModalStyle(item)}
          modal
          open={onModalOpen(item, props)}
          onClose={close}
          closeOnDocumentClick={false}
        >
          {getModal(item, currentUser)}
        </Popup>
      ))}
    </>
  );
};

Modals.propTypes = {
  close: Proptypes.func,
  currentUser: Proptypes.object,
  isTrial: Proptypes.bool,
  availableSubscriptions: Proptypes.number,
  trialEndDate: Proptypes.string,
  currentLoggedEmail: Proptypes.string,
  actions: Proptypes.array,
  editProfileModalOpen: Proptypes.bool,
  resetPasswordModalOpen: Proptypes.bool,
  removeUserModalOpen: Proptypes.bool,
  resendInviteModalOpen: Proptypes.bool,
  removeInviteModalOpen: Proptypes.bool,
  updatePermissionsModalOpen: Proptypes.bool,
  assignToTeamsModalOpen: Proptypes.bool,
};

const mapStateToProps = (state) => {
  return {
    currentLoggedEmail: ProfileSelectors.profileEmailSelector(state),
    currentUser: UsersSelectors.currentClickedUserSelector(state),
    editProfileModalOpen: UsersSelectors.updateProfileModalSelector(state),
    resetPasswordModalOpen: UsersSelectors.resetPasswordModalSelector(state),
    removeUserModalOpen: UsersSelectors.removeUserModalSelector(state),
    resendInviteModalOpen: UsersSelectors.resendInviteModalSelector(state),
    removeInviteModalOpen: UsersSelectors.removeInviteModalSelector(state),
    updatePermissionsModalOpen: UsersSelectors.updatePermissionsModalSelector(state),
    assignToTeamsModalOpen: UsersSelectors.assignToTeamsModalSelector(state),
  };
};

const mapDispatchToProps = {
  close: UsersActions.clickedCloseModalButton,
};

export default connect(mapStateToProps, mapDispatchToProps)(Modals);
